import { Component, OnInit } from '@angular/core';
import { ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
  selector: 'app-information-dashboard',
  templateUrl: './information-dashboard.component.html',
  styleUrls: ['./information-dashboard.component.css']
})
export class InformationDashboardComponent implements OnInit {

  constructor() { }
  // lineChart Data

  ngOnInit(): void {
  }


}
